import React, { useState } from 'react';
import { Button, TextField, Grid } from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
import UserService from '../../../../../../services/main/User.service';
import BlockUser from '../../../../../../models/pages/user/BlockUser';
import Toasters from '../../../../../../components/popUp/PopUp';
import useStyles from '../BlockUser.style';
import Loader from '../../../../../../components/loader/Loader';
import { EmptyVoidFunction } from '../../../../../../utils/types/Types';
import useTranslation from '../../../../../../components/localization/customHooks/Translation';

const defaultProps = {
  handleClose: () => {},
};

export default function BlockUserModal(props: {
  isBlockedText: string;
  isBlocked: boolean;
  userId: string;
  lockoutMessage: string | null;
  handleClose?: EmptyVoidFunction;
}) {
  const { isBlockedText, isBlocked, userId, lockoutMessage, handleClose } = props;
  const l10n = useTranslation();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { isDirty, isValid },
  } = useForm<BlockUser>({
    mode: 'onBlur',
  });

  const sendRequest = async (data: BlockUser) => {
    const result = { ...data };
    result.userId = userId;
    setLoader(true);
    const response = isBlocked ? await UserService.unBlockUser(result) : await UserService.blockUser(result);
    if (response) {
      Toasters.success(l10n.components.toasterMessage.getBlockingMessage(isBlocked));
    }
    if (handleClose) {
      handleClose();
    }
    setLoader(false);
  };
  if (loader) {
    return (
      <Grid className={classes.loadingWindow}>
        <Loader />
      </Grid>
    );
  }
  return (
    <form onSubmit={handleSubmit(sendRequest)} className={classes.root}>
      <Controller
        render={({ field }) => (
          <TextField
            {...field}
            inputProps={{ readOnly: !!lockoutMessage }}
            className={classes.content}
            id="outlined-multiline-static"
            label={l10n.components.label.REASON_OF_BLOCKING}
            multiline
            rows={4}
            variant="outlined"
            required
            autoFocus
          />
        )}
        name="message"
        control={control}
        defaultValue={lockoutMessage || ''}
      />
      <Button
        type="submit"
        data-testid="block"
        variant="contained"
        color="primary"
        className={classes.content}
        disabled={!isBlocked && (!isDirty || !isValid)}
      >
        {isBlockedText}
      </Button>
    </form>
  );
}

BlockUserModal.defaultProps = defaultProps;
